export const requestPassword = formatted => fetch( '/api/account/password/renew',{
        method: 'POST',
        body: JSON.stringify(formatted),
        headers: { "Content-Type": "application/json" }
    }).catch(e => {
        console.log(e);
    })


export const isConnected = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_U1_GATEWAY_BASE_URL + '/connected', {
            method: 'GET',
            credentials: 'include'
        });
        return response.ok;
    } catch (error) {
        console.error('isConnected error:', error);
        return false;
    }
}

export const getRemainingLoginAttempts = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_U1_GATEWAY_BASE_URL + '/login/attempts', {
            method: 'GET',
            credentials: 'include'
        });
        if (response.ok) {
            const data = await response.json();
            return data.remainingAttempts;
        }
        return 5;
    } catch (error) {
        console.error('getRemainingLoginAttempts error:', error);
        return 5;
    }
}

export const getLiveAccess = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_U1_GATEWAY_BASE_URL + '/user/role/live-access', {
            method: 'GET',
            credentials: 'include'
        });
        if (response.ok) {
            const data = await response.json();
            return data?.liveAccess === true;
        }
        return false;
    } catch (error) {
        console.error('getLiveAccess error:', error);
        return false;
    }
}